
export default {
  name: 'articles',
  components: {},
  props: [],
  data () {
    return {
        fields: ['libelle', 'prix', 'libelle', 'minimum','type_article','date', 'actions'],
        filter: "",
        perPage: 3,
        currentPage: 1,
        
    }
  },
  computed: {
    articles() {
        return this.$store.getters['articles']
    },


  },
  mounted () {
    this.$store.dispatch("getArticles");

  },
  methods: {

  }
}


